import { ACCOUNT_TYPE } from "../utils/constants";
export const sidebarLinks = [
  {
    id: 1,
    name: "My Profile",
    path: "/dashboard/my-profile",
    icon: "VscAccount",
  },
  {
    id: 2,
    name: "Dashboard",
    path: "/dashboard/instructor",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscDashboard",
  },
  {
    id: 3,
    name: "My Courses",
    path: "/dashboard/my-courses",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscVm",
  },
  {
    id: 4,
    name: "Add Course",
    path: "/dashboard/add-course",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscAdd",
  },
  {
    id: 5,
    name: "Catgories",
    path: "/dashboard/categories",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscSymbolConstant",
  },
  {
    id: 5,
    name: "Enrolled Courses",
    path: "/dashboard/enrolled-courses",
    type: ACCOUNT_TYPE.USER,
    icon: "VscMortarBoard",
  },
  {
    id: 6,
    name: "Your Cart",
    path: "/dashboard/cart",
    type: ACCOUNT_TYPE.USER,
    icon: "VscPackage",
  },
  {
    id: 7,
    name: "My Blogs",
    path: "/dashboard/blogs",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscBook",
  },
  {
    id: 8,
    name: "My Events",
    path: "/dashboard/events",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscCalendar",
  },
  {
    id: 9,
    name: "Newsletter",
    path: "/dashboard/newsletter",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscCommentDiscussion",
  },
  {
    id: 10,
    name: "Coupons",
    path: "/dashboard/coupons",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscCreditCard",
  },
  {
    id: 11,
    name: "Invoices",
    path: "/dashboard/invoices",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscChecklist",
  },
  {
    id: 12,
    name: "Certificates",
    path: "/dashboard/certificates",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscClippy",
  },
  {
    id: 13,
    name: "Update Stats",
    path: "/dashboard/updateStats",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscBroadcast",
  },
  {
    id: 14,
    name: "User Report",
    path: "/dashboard/userReports",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscBriefcase",
  },
  {
    id: 15,
    name: "Security Event",
    path: "/dashboard/securityEvents",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscBellDot",
  },
  {
    id: 18,
    name: "Add Program",
    path: "/dashboard/add-program",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscAdd",
  },
  {
    id: 19,
    name: "Add Mentorship",
    path: "/dashboard/add-mentorship",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscAdd",
  },
  {
    id: 16,
    name: "Video Testimonial",
    path: "/dashboard/video-testimonial",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscPlayCircle",
  },
  {
    id: 17,
    name: "Home Banners",
    path: "/dashboard/home-banners",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscPreview",
  },
  {
    id: 20,
    name: "Free Learning Videos",
    path: "/dashboard/free-learning-videos",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscPlayCircle",
  },
  {
    id: 21,
    name: "Page Content",
    path: "/dashboard/page-content",
    type: ACCOUNT_TYPE.ADMIN,
    icon: "VscEdit",
  },
];
